export const AutomationRuntime = () => null

export default AutomationRuntime